// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 768px) {
  .bottomModal {
    position: fixed;
    bottom: -100%;
    left: 0;
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.45);
    transition: bottom 0.3s ease-in-out;
    z-index: 10000;
  }
  .bottomModal.show {
    bottom: 0;
  }
}
.bottomModal .bottomModalHeaderContent {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #E8E8E8;
  padding: 12px;
}
.bottomModal .reviewDetail {
  border-bottom: none;
  padding: 0 12px;
  padding-top: 20px;
}
.bottomModal .reviewDetail .reviewDetailHeader {
  width: 40px;
  background-color: #EA2466;
  height: 5px;
  border-radius: 4px;
  position: absolute;
  top: 12px;
  left: 12px;
}
.bottomModal .reviewDetail .bottomModalHeaderContentTitle {
  font-size: 18px;
}
.bottomModal .reviewDetail .crossIcon svg {
  width: 20px;
  height: 20px;
}
.bottomModal .fullViewBottomModalHeaderContent {
  position: fixed;
  width: 100%;
  z-index: 10000;
  background: #ffffff;
}
.bottomModal .bottomModalHeaderContentTitle {
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
}
.bottomModal .fixedButtonGroup {
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
}
.bottomModal .doneBtn {
  width: 100%;
  padding: 12px 30px;
  border-radius: 20px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  height: auto;
}
@media (max-width: 768px) {
  .bottomModal .doneBtn {
    padding: 8px 28px !important;
    width: auto;
  }
}
.bottomModal .secondaryButton {
  padding: 0px 12px 12px 12px;
}
.bottomModal .travellerCount {
  padding-bottom: 0;
  border-bottom: none;
  margin-bottom: 0;
}

.reviewModal {
  border-radius: 12px;
  z-index: 9999;
}

.centerModal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 500px;
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.45);
  transition: transform 0.3s ease-in-out;
  z-index: 10000;
}
@media (max-width: 768px) {
  .centerModal {
    max-width: 300px;
  }
}
.centerModal .centerModalHeaderContent {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #E8E8E8;
  padding: 12px 20px;
}
@media (max-width: 768px) {
  .centerModal .centerModalHeaderContent {
    padding: 12px;
  }
}
.centerModal .centerModalHeaderContent .headerTitleSection {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.centerModal .centerModalHeaderContent .headerTitleSection .centerModalHeaderContentSubTitle {
  font-size: 11px;
  font-weight: 400;
  color: #4b5563;
}
.centerModal .fullViewCenterModalHeaderContent {
  position: fixed;
  width: 100%;
  z-index: 10000;
  background: #ffffff;
}
.centerModal .centerModalHeaderContentTitle {
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
}
@media (max-width: 768px) {
  .centerModal .centerModalHeaderContentTitle {
    font-size: 14px;
  }
}

.crossIcon svg {
  fill: #4a4a4a;
  width: 20px;
  height: 20px;
}

.noTitleCrossIcon {
  width: 100%;
  position: absolute;
  border: none;
  background: transparent;
  display: flex;
}
.noTitleCrossIcon svg {
  margin: 10px 10px 0 auto;
  width: 16px;
  height: 16px;
}

.fullViewBottomModal {
  top: 0;
  overflow: auto;
}

.transactionModalWrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}
.transactionModalWrapper .transactionModal {
  position: relative;
  background: #ffffff;
  border-radius: 24px;
  padding: 48px 24px 24px;
  max-width: 480px;
  width: 90%;
  max-height: 90vh;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  animation: modalSlideIn 0.3s ease-out;
}
@media (max-width: 768px) {
  .transactionModalWrapper .transactionModal {
    padding: 32px 24px;
    margin: 20px;
    max-width: calc(100vw - 40px);
  }
}
.transactionModalWrapper .transactionModal .closeButton {
  background-color: var(--closeButtonBg);
  color: var(--closeButtonColor);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  padding: 8px;
  position: absolute;
  right: 12px;
  top: 12px;
  transition: all 0.2s ease;
  width: 36px;
  height: 36px;
}
.transactionModalWrapper .transactionModal .closeButton svg {
  width: 20px;
  height: 20px;
}
.transactionModalWrapper .transactionModal .modalContent {
  text-align: center;
}
.transactionModalWrapper .transactionModal .modalContent .modalHeader {
  margin-bottom: 24px;
}
.transactionModalWrapper .transactionModal .modalContent .modalHeader .iconContainer {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin: 0 auto;
}
.transactionModalWrapper .transactionModal .modalContent .modalHeader .iconContainer.error {
  background: linear-gradient(135deg, rgba(235, 0, 0, 0.1) 0%, rgba(235, 0, 0, 0.2) 100%);
}
.transactionModalWrapper .transactionModal .modalContent .modalHeader .iconContainer.info {
  background: linear-gradient(135deg, rgba(234, 36, 102, 0.1) 0%, rgba(234, 36, 102, 0.2) 100%);
}
.transactionModalWrapper .transactionModal .modalContent .modalHeader .iconContainer.success {
  background: linear-gradient(135deg, rgba(234, 36, 102, 0.1) 0%, rgba(234, 36, 102, 0.2) 100%);
}
.transactionModalWrapper .transactionModal .modalContent .modalHeader .iconContainer .modalIcon {
  font-size: 40px;
}
.transactionModalWrapper .transactionModal .modalContent .modalHeader .iconContainer .modalIcon.error {
  color: #EB0000;
}
.transactionModalWrapper .transactionModal .modalContent .modalHeader .iconContainer .modalIcon.success {
  color: #EA2466;
}
.transactionModalWrapper .transactionModal .modalContent .modalBody {
  margin-bottom: 32px;
}
.transactionModalWrapper .transactionModal .modalContent .modalBody .modalTitle {
  font-size: 24px;
  font-weight: 700;
  color: #383838;
  margin: 0 0 16px 0;
  line-height: 1.3;
}
.transactionModalWrapper .transactionModal .modalContent .modalBody .modalMessage {
  font-size: 16px;
  color: #616161;
  line-height: 1.6;
  margin: 0;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  white-space: pre-line;
}
.transactionModalWrapper .transactionModal .modalContent .modalFooter {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}
@media (max-width: 480px) {
  .transactionModalWrapper .transactionModal .modalContent .modalFooter {
    flex-direction: column;
  }
}
.transactionModalWrapper .transactionModal .modalContent .modalFooter .btnTryAgain {
  background: #00A664;
  color: #ffffff;
  border: none;
  padding: 12px 32px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
}
.transactionModalWrapper .transactionModal .modalContent .modalFooter .btnTryAgain:hover {
  background: rgb(0, 115, 69.2771084337);
  transform: translateY(-1px);
  box-shadow: 0 8px 25px rgba(0, 166, 100, 0.3);
}
.transactionModalWrapper .transactionModal .modalContent .modalFooter .btnTryAgain:active {
  transform: translateY(0);
}
.transactionModalWrapper .transactionModal .modalContent .modalFooter .btnCancel {
  padding: 12px 32px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
  background-color: var(--btnCancelBg);
  color: var(--btnCancelColor);
}
.transactionModalWrapper .transactionModal.transactionModal--leadSuccess {
  max-width: 450px;
  width: min(450px, 100vw - 40px);
  padding: 48px 52px 42px;
  border-radius: 20px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.22);
}
.transactionModalWrapper .transactionModal.transactionModal--leadSuccess .modalContent .modalHeader {
  margin-bottom: 28px;
}
.transactionModalWrapper .transactionModal.transactionModal--leadSuccess .modalContent .modalHeader .iconContainer {
  width: 76px;
  height: 76px;
}
.transactionModalWrapper .transactionModal.transactionModal--leadSuccess .modalContent .modalHeader .iconContainer .modalIcon {
  width: 30px;
  height: 30px;
  stroke-width: 2.8;
}
.transactionModalWrapper .transactionModal.transactionModal--leadSuccess .modalContent .modalBody {
  margin-bottom: 32px;
}
.transactionModalWrapper .transactionModal.transactionModal--leadSuccess .modalContent .modalBody .modalTitle {
  max-width: 460px;
  margin: 0 auto 20px;
  font-size: 24px;
  line-height: 1.22;
  font-weight: 700;
  letter-spacing: 0;
}
.transactionModalWrapper .transactionModal.transactionModal--leadSuccess .modalContent .modalBody .modalMessage {
  max-width: 450px;
  font-size: 16px;
  line-height: 1.58;
  color: #616161;
}
.transactionModalWrapper .transactionModal.transactionModal--leadSuccess .modalContent .modalFooter .btnCancel {
  min-width: 220px;
  height: 50px;
  padding: 0 34px;
  border-radius: 8px;
  border: 0;
  font-size: 16px;
  box-shadow: 0 10px 24px rgba(234, 36, 102, 0.26);
}
@media (max-width: 768px) {
  .transactionModalWrapper .transactionModal.transactionModal--leadSuccess {
    width: calc(100vw - 32px);
    margin: 16px;
    padding: 40px 28px 32px;
    border-radius: 18px;
  }
  .transactionModalWrapper .transactionModal.transactionModal--leadSuccess .modalContent .modalHeader {
    margin-bottom: 24px;
  }
  .transactionModalWrapper .transactionModal.transactionModal--leadSuccess .modalContent .modalHeader .iconContainer {
    width: 72px;
    height: 72px;
  }
  .transactionModalWrapper .transactionModal.transactionModal--leadSuccess .modalContent .modalHeader .iconContainer .modalIcon {
    width: 28px;
    height: 28px;
  }
  .transactionModalWrapper .transactionModal.transactionModal--leadSuccess .modalContent .modalBody {
    margin-bottom: 30px;
  }
  .transactionModalWrapper .transactionModal.transactionModal--leadSuccess .modalContent .modalBody .modalTitle {
    font-size: 20px;
    line-height: 1.22;
    margin-bottom: 18px;
  }
  .transactionModalWrapper .transactionModal.transactionModal--leadSuccess .modalContent .modalBody .modalMessage {
    max-width: 100%;
    font-size: 16px;
    line-height: 1.52;
  }
  .transactionModalWrapper .transactionModal.transactionModal--leadSuccess .modalContent .modalFooter .btnCancel {
    width: 100%;
    min-width: 0;
    height: 52px;
    font-size: 14px;
  }
}
@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.transactionModalWrapper .contactModalOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  color: #000000;
}
.transactionModalWrapper .contactModalOverlay .contactModal {
  background: #ffffff;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}
@media (max-width: 768px) {
  .transactionModalWrapper .contactModalOverlay .contactModal {
    max-width: 400px;
    margin: 10px;
  }
}
.transactionModalWrapper .contactModalOverlay .modalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 24px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 24px;
}
.transactionModalWrapper .contactModalOverlay .modalHeader h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #111827;
}
@media (max-width: 768px) {
  .transactionModalWrapper .contactModalOverlay .modalHeader h2 {
    font-size: 20px;
  }
}
.transactionModalWrapper .contactModalOverlay .modalHeader .closeBtn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  color: #6b7280;
  transition: all 0.2s ease;
}
.transactionModalWrapper .contactModalOverlay .modalHeader .closeBtn:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.transactionModalWrapper .contactModalOverlay .modalHeader .closeBtn:focus {
  outline: 2px solid #EA2466;
  outline-offset: 2px;
}
.transactionModalWrapper .contactModalOverlay .modalForm {
  padding: 0 24px 24px;
}
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup {
  margin-bottom: 20px;
}
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup input,
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s ease;
  font-family: inherit;
}
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup input:focus,
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup textarea:focus {
  outline: none;
  border-color: #EA2466;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup input::placeholder,
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup textarea::placeholder {
  color: #9ca3af;
}
@media (max-width: 768px) {
  .transactionModalWrapper .contactModalOverlay .modalForm .formGroup input,
  .transactionModalWrapper .contactModalOverlay .modalForm .formGroup textarea {
    font-size: 16px;
  }
}
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup textarea {
  resize: vertical;
  min-height: 100px;
}
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup .react-tel-input .contact-phone-input {
  width: 100% !important;
  padding: 12px 16px 12px 58px !important;
  border: 1px solid #d1d5db !important;
  border-radius: 8px !important;
  font-size: 16px !important;
  transition: all 0.2s ease !important;
  font-family: inherit !important;
  height: 50px;
}
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup .react-tel-input .contact-phone-input:focus {
  outline: none !important;
  border-color: #EA2466 !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
}
@media (max-width: 768px) {
  .transactionModalWrapper .contactModalOverlay .modalForm .formGroup .react-tel-input .contact-phone-input {
    font-size: 16px !important;
  }
}
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup .react-tel-input .flag-dropdown {
  border: 1px solid #d1d5db !important;
  border-radius: 8px 0 0 8px !important;
  background: #f9fafb !important;
}
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup .react-tel-input .flag-dropdown:hover {
  background: #f3f4f6 !important;
}
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup .react-tel-input .flag-dropdown .selected-flag {
  padding: 0 8px !important;
}
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup .react-tel-input .flag-dropdown .selected-flag:hover {
  background: transparent !important;
}
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup .error {
  color: #ef4444;
  font-size: 14px;
  margin-top: 4px;
  margin-bottom: 0;
}
.transactionModalWrapper .contactModalOverlay .modalForm .formGroup .error.phoneError {
  margin-top: 4px;
}
.transactionModalWrapper .contactModalOverlay .modalForm .success-message {
  background-color: #dcfce7;
  color: #166534;
  padding: 12px 16px;
  border-radius: 8px;
  margin-top: 16px;
  font-size: 14px;
  border-left: 4px solid #00A664;
}
.transactionModalWrapper .contactModalOverlay .modalActions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 32px;
}
@media (max-width: 768px) {
  .transactionModalWrapper .contactModalOverlay .modalActions {
    flex-direction: column-reverse;
    gap: 8px;
  }
}
.transactionModalWrapper .contactModalOverlay .modalActions .cancelBtn,
.transactionModalWrapper .contactModalOverlay .modalActions .submitBtn {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}
@media (max-width: 768px) {
  .transactionModalWrapper .contactModalOverlay .modalActions .cancelBtn,
  .transactionModalWrapper .contactModalOverlay .modalActions .submitBtn {
    width: 100%;
    padding: 14px 24px;
  }
}
.transactionModalWrapper .contactModalOverlay .modalActions .cancelBtn:disabled,
.transactionModalWrapper .contactModalOverlay .modalActions .submitBtn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.transactionModalWrapper .contactModalOverlay .modalActions .cancelBtn {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
}
.transactionModalWrapper .contactModalOverlay .modalActions .cancelBtn:hover:not(:disabled) {
  background: #e5e7eb;
}
.transactionModalWrapper .contactModalOverlay .modalActions .cancelBtn:focus {
  outline: 2px solid #6b7280;
  outline-offset: 2px;
}
.transactionModalWrapper .contactModalOverlay .modalActions .submitBtn {
  background: #EA2466;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}
.transactionModalWrapper .contactModalOverlay .modalActions .submitBtn:hover:not(:disabled) {
  background: #EA2466;
}
.transactionModalWrapper .contactModalOverlay .modalActions .submitBtn:focus {
  outline: 2px solid #EA2466;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/Styles/_mixins.scss","webpack://./src/Components/Partials/Modal/Modal.scss","webpack://./src/Styles/_colors.scss"],"names":[],"mappings":"AAYE;ECXF;IAEI,eAAA;IACA,aAAA;IACA,OAAA;IACA,WAAA;IACA,yBCHU;IDIV,0CAAA;IACA,mCAAA;IACA,cAAA;EAAF;EAEE;IACE,SAAA;EAAJ;AACF;AAGE;EACE,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,aAAA;AADJ;AAIE;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;AAFJ;AAII;EACE,WAAA;EACA,yBCvBe;EDwBf,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAFN;AAKI;EACE,eAAA;AAHN;AAOM;EACE,WAAA;EACA,YAAA;AALR;AAUE;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,mBCnDU;AD2Cd;AAWE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AATJ;AAYE;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,yBChEU;EDiEV,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAVJ;AAaE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAXJ;AD3DE;EC+DA;IAWI,4BAAA;IACA,WAAA;EAXJ;AACF;AAcE;EACE,2BAAA;AAZJ;AAeE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AAbJ;;AAiBA;EACE,mBAAA;EACA,aAAA;AAdF;;AAiBA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBC/GY;EDgHZ,0CAAA;EACA,sCAAA;EACA,cAAA;AAdF;AD5FE;EC+FF;IAcI,gBAAA;EAbF;AACF;AAeE;EACE,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,kBAAA;AAbJ;ADvGE;ECgHA;IAOI,aAAA;EAZJ;AACF;AAcI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAZN;AAcM;EACE,eAAA;EACA,gBAAA;EACA,cCrES;ADyDjB;AAiBE;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,mBCnJU;ADoId;AAkBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAhBJ;ADjIE;EC8IA;IAMI,eAAA;EAfJ;AACF;;AAoBE;EACE,aC5JwB;ED6JxB,WAAA;EACA,YAAA;AAjBJ;;AAqBA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;AAlBF;AAoBE;EACE,wBAAA;EACA,WAAA;EACA,YAAA;AAlBJ;;AAsBA;EACE,MAAA;EACA,cAAA;AAnBF;;AAuBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kCAAA;UAAA,0BAAA;AApBF;AAsBE;EACE,kBAAA;EACA,mBC5MU;ED6MV,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,0CAAA;EACA,qCAAA;AApBJ;ADvLE;ECkMA;IAYI,kBAAA;IACA,YAAA;IACA,6BAAA;EAnBJ;AACF;AAqBI;EACE,sCAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AAnBN;AAqBM;EACE,WAAA;EACA,YAAA;AAnBR;AAuBI;EACE,kBAAA;AArBN;AAuBM;EACE,mBAAA;AArBR;AAuBQ;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AArBV;AAuBU;EACE,uFAAA;AArBZ;AAwBU;EACE,6FAAA;AAtBZ;AAyBU;EACE,6FAAA;AAvBZ;AA0BU;EACE,eAAA;AAxBZ;AA0BY;EACE,cCvPF;AD+NZ;AA2BY;EACE,cC9QO;ADqPrB;AA+BM;EACE,mBAAA;AA7BR;AA+BQ;EACE,eAAA;EACA,gBAAA;EACA,cCxRgB;EDyRhB,kBAAA;EACA,gBAAA;AA7BV;AAgCQ;EACE,eAAA;EACA,cC1RQ;ED2RR,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;AA9BV;AAkCM;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AAhCR;AAkCQ;EANF;IAOI,sBAAA;EA/BR;AACF;AAiCQ;EACE,mBCrSI;EDsSJ,cC3TI;ED4TJ,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AA/BV;AAiCU;EACE,sCAAA;EACA,2BAAA;EACA,6CAAA;AA/BZ;AAkCU;EACE,wBAAA;AAhCZ;AAoCQ;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,oCAAA;EACA,4BAAA;AAlCV;AAuCI;EACE,gBAAA;EACA,+BAAA;EACA,uBAAA;EACA,mBAAA;EACA,2CAAA;AArCN;AAwCQ;EACE,mBAAA;AAtCV;AAwCU;EACE,WAAA;EACA,YAAA;AAtCZ;AAwCY;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAtCd;AA2CQ;EACE,mBAAA;AAzCV;AA2CU;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAzCZ;AA4CU;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC1XM;ADgVlB;AA+CU;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,gDAAA;AA7CZ;AD5VE;ECsVE;IAyDI,yBAAA;IACA,YAAA;IACA,uBAAA;IACA,mBAAA;EA/CN;EAkDQ;IACE,mBAAA;EAhDV;EAkDU;IACE,WAAA;IACA,YAAA;EAhDZ;EAkDY;IACE,WAAA;IACA,YAAA;EAhDd;EAqDQ;IACE,mBAAA;EAnDV;EAqDU;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;EAnDZ;EAsDU;IACE,eAAA;IACA,eAAA;IACA,iBAAA;EApDZ;EAyDU;IACE,WAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;EAvDZ;AACF;AA8DA;EACE;IACE,UAAA;IACA,wCAAA;EA5DF;EA8DA;IACE,UAAA;IACA,iCAAA;EA5DF;AACF;AAgEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;EACA,cC/dY;ADiad;AAgEE;EACE,mBCneU;EDoeV,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qFAAA;AA9DJ;ADnaE;EC0dA;IAUI,gBAAA;IACA,YAAA;EA7DJ;AACF;AAgEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AA9DJ;AAgEI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cCrbW;ADuXjB;ADvbE;ECifE;IAOI,eAAA;EA7DN;AACF;AAgEI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,cCtcW;EDucX,yBAAA;AA9DN;AAgEM;EACE,yBC9cS;ED+cT,cCzcS;AD2YjB;AAiEM;EACE,0BAAA;EACA,mBAAA;AA/DR;AAoEE;EACE,oBAAA;AAlEJ;AAoEI;EACE,mBAAA;AAlEN;AAoEM;;EAEE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;AAlER;AAoEQ;;EACE,aAAA;EACA,qBCviBW;EDwiBX,6CAAA;AAjEV;AAoEQ;;EACE,cC7eO;AD4ajB;ADveE;ECuhBI;;IAqBI,eAAA;EAhER;AACF;AAmEM;EACE,gBAAA;EACA,iBAAA;AAjER;AAsEQ;EACE,sBAAA;EACA,uCAAA;EACA,oCAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,+BAAA;EACA,YAAA;AApEV;AAsEU;EACE,wBAAA;EACA,gCAAA;EACA,wDAAA;AApEZ;ADhgBE;ECujBM;IAiBI,0BAAA;EApEV;AACF;AAuEQ;EACE,oCAAA;EACA,qCAAA;EACA,8BAAA;AArEV;AAuEU;EACE,8BAAA;AArEZ;AAwEU;EACE,yBAAA;AAtEZ;AAwEY;EACE,kCAAA;AAtEd;AA4EM;EACE,cCveQ;EDweR,eAAA;EACA,eAAA;EACA,gBAAA;AA1ER;AA4EQ;EACE,eAAA;AA1EV;AA+EI;EACE,yBCngBY;EDogBZ,cC7fY;ED8fZ,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;AA7EN;AAiFE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;AA/EJ;AD3iBE;ECsnBA;IAOI,8BAAA;IACA,QAAA;EA9EJ;AACF;AAgFI;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AA9EN;AD3jBE;ECioBE;;IAWI,WAAA;IACA,kBAAA;EA5EN;AACF;AA8EM;;EACE,mBAAA;EACA,YAAA;AA3ER;AA+EI;EACE,mBC/lBW;EDgmBX,cC1lBW;ED2lBX,yBAAA;AA7EN;AA+EM;EACE,mBCnmBS;ADshBjB;AAgFM;EACE,0BAAA;EACA,mBAAA;AA9ER;AAkFI;EACE,mBC1qBe;ED2qBf,cC/qBQ;EDgrBR,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;AAhFN;AAkFM;EACE,mBClrBa;ADkmBrB;AAmFM;EACE,0BAAA;EACA,mBAAA;AAjFR","sourcesContent":["@import './breakpoints';\n\n// ====================================\n// 📱 Media Query Mixins\n// ====================================\n@mixin respond-sm {\n  @media (max-width: $breakpoint-sm) {\n    @content;\n  }\n}\n\n@mixin respond-md {\n  @media (max-width: $breakpoint-md) {\n    @content;\n  }\n}\n\n@mixin respond-lg {\n  @media (max-width: $breakpoint-lg) {\n    @content;\n  }\n}\n\n@mixin respond-xlg {\n  @media (max-width: $breakpoint-xlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxlg {\n  @media (max-width: $breakpoint-xxlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxxlg {\n  @media (max-width: $breakpoint-xxxlg) {\n    @content;\n  }\n}\n\n@mixin respond-max {\n  @media (max-width: $breakpoint-max) {\n    @content;\n  }\n}\n","@import \"src/Styles/theme.scss\";\n.bottomModal {\n  @include respond-md {\n    position: fixed;\n    bottom: -100%; // Initially hidden\n    left: 0;\n    width: 100%;\n    background-color: $color-white;\n    box-shadow: 0 0 20px 0 rgba($color-black , 0.45);\n    transition: bottom 0.3s ease-in-out; // Smooth animation\n    z-index: 10000;\n\n    &.show {\n      bottom: 0; // Slide up effect\n    }\n  }\n\n  .bottomModalHeaderContent {\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px solid $bg-light-grey-1;\n    padding: 12px;\n  }\n\n  .reviewDetail {\n    border-bottom: none;\n    padding: 0 12px;\n    padding-top: 20px;\n\n    .reviewDetailHeader {\n      width: 40px;\n      background-color: $color-primary-pink;\n      height: 5px;\n      border-radius: 4px;\n      position: absolute;\n      top: 12px;\n      left: 12px;\n    }\n\n    .bottomModalHeaderContentTitle {\n      font-size: 18px;\n    }\n\n    .crossIcon {\n      svg {\n        width: 20px;\n        height: 20px;\n      }\n    }\n  }\n\n  .fullViewBottomModalHeaderContent {\n    position: fixed;\n    width: 100%;\n    z-index: 10000;\n    background: $color-white;\n  }\n\n  .bottomModalHeaderContentTitle {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: normal;\n  }\n\n  .fixedButtonGroup {\n    position: fixed;\n    width: 100%;\n    bottom: 0;\n    background-color: $color-white;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    gap: 20px;\n  }\n\n  .doneBtn {\n    width: 100%;\n    padding: 12px 30px;\n    border-radius: 20px;\n    font-size: 14px;\n    line-height: 16px;\n    font-weight: 600;\n    height: auto;\n    // margin: 12px;\n\n    @include respond-md {\n      padding: 8px 28px !important;\n      width: auto;\n    }\n  }\n\n  .secondaryButton {\n    padding: 0px 12px 12px 12px;\n  }\n\n  .travellerCount {\n    padding-bottom: 0;\n    border-bottom: none;\n    margin-bottom: 0;\n  }\n}\n\n.reviewModal {\n  border-radius: 12px;\n  z-index: 9999;\n}\n\n.centerModal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  max-width: 500px;\n  border-radius: 6px;\n  background-color: $color-white;\n  box-shadow: 0 0 20px 0 rgba($color-black, 0.45);\n  transition: transform 0.3s ease-in-out;\n  z-index: 10000;\n\n  @include respond-md {\n    max-width: 300px;\n  }\n\n  .centerModalHeaderContent {\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px solid $bg-light-grey-1;\n    padding: 12px 20px;\n\n    @include respond-md {\n      padding: 12px;\n    }\n\n    .headerTitleSection {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      .centerModalHeaderContentSubTitle {\n        font-size: 11px;\n        font-weight: 400;\n        color: $color-gray-600;\n      }\n    }\n  }\n\n  .fullViewCenterModalHeaderContent {\n    position: fixed;\n    width: 100%;\n    z-index: 10000;\n    background: $color-white;\n  }\n\n  .centerModalHeaderContentTitle {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: normal;\n\n    @include respond-md {\n      font-size: 14px;\n    }\n  }\n}\n\n.crossIcon {\n  svg {\n    fill: $color-primary-medium-grey;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.noTitleCrossIcon {\n  width: 100%;\n  position: absolute;\n  border: none;\n  background: transparent;\n  display: flex;\n\n  svg {\n    margin: 10px 10px 0 auto;\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.fullViewBottomModal {\n  top: 0;\n  overflow: auto;\n}\n\n\n.transactionModalWrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba($color-black, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  backdrop-filter: blur(2px);\n\n  .transactionModal {\n    position: relative;\n    background: $color-white;\n    border-radius: 24px;\n    padding: 48px 24px 24px;\n    max-width: 480px;\n    width: 90%;\n    max-height: 90vh;\n    box-shadow: 0 20px 60px rgba($color-black, 0.2);\n    animation: modalSlideIn 0.3s ease-out;\n    \n    @include respond-md {\n      padding: 32px 24px;\n      margin: 20px;\n      max-width: calc(100vw - 40px);\n    }\n\n    .closeButton {\n      background-color: var(--closeButtonBg);\n      color: var(--closeButtonColor);\n      border: none;\n      border-radius: 50%;\n      cursor: pointer;\n      padding: 8px;\n      position: absolute;\n      right: 12px;\n      top: 12px;\n      transition: all 0.2s ease;\n      width: 36px;\n      height: 36px;\n\n      svg {\n        width: 20px;\n        height: 20px;\n      }\n    }\n\n    .modalContent {\n      text-align: center;\n\n      .modalHeader {\n        margin-bottom: 24px;\n\n        .iconContainer {\n          display: inline-flex;\n          align-items: center;\n          justify-content: center;\n          width: 80px;\n          height: 80px;\n          border-radius: 50%;\n          margin: 0 auto;\n          \n          &.error {\n            background: linear-gradient(135deg, rgba($color-red, 0.1) 0%, rgba($color-red, 0.2) 100%);\n          }\n          \n          &.info {\n            background: linear-gradient(135deg, rgba($color-primary-pink, 0.1) 0%, rgba($color-primary-pink, 0.2) 100%);\n          }\n\n          &.success {\n            background: linear-gradient(135deg, rgba($color-primary-pink, 0.1) 0%, rgba($color-primary-pink, 0.2) 100%);\n          }\n\n          .modalIcon {\n            font-size: 40px;\n            \n            &.error {\n              color: $color-red;\n            }\n            \n            &.success {\n              color: $color-primary-pink;\n      }\n    }\n  }\n}\n\n      .modalBody {\n        margin-bottom: 32px;\n\n        .modalTitle {\n          font-size: 24px;\n          font-weight: 700;\n          color: $color-primary-dark-grey;\n          margin: 0 0 16px 0;\n          line-height: 1.3;\n        }\n\n        .modalMessage {\n          font-size: 16px;\n          color: $color-text-grey;\n          line-height: 1.6;\n          margin: 0;\n          max-width: 400px;\n          margin-left: auto;\n          margin-right: auto;\n          white-space: pre-line;\n        }\n      }\n\n      .modalFooter {\n        display: flex;\n        gap: 12px;\n        justify-content: center;\n        flex-wrap: wrap;\n        \n        @media (max-width: 480px) {\n          flex-direction: column;\n        }\n\n        .btnTryAgain {\n          background: $color-green;\n          color: $color-white;\n          border: none;\n          padding: 12px 32px;\n          border-radius: 12px;\n          font-weight: 600;\n          font-size: 16px;\n          cursor: pointer;\n          transition: all 0.2s ease;\n          min-width: 120px;\n          \n          &:hover {\n            background: darken($color-green, 10%);\n            transform: translateY(-1px);\n            box-shadow: 0 8px 25px rgba($color-green, 0.3);\n          }\n          \n          &:active {\n            transform: translateY(0);\n          }\n        }\n\n        .btnCancel {\n          padding: 12px 32px;\n          border-radius: 6px;\n          font-weight: 600;\n          font-size: 16px;\n          cursor: pointer;\n          transition: all 0.2s ease;\n          min-width: 120px;\n          background-color: var(--btnCancelBg);\n          color: var(--btnCancelColor);\n        }\n      }\n    }\n\n    &.transactionModal--leadSuccess {\n      max-width: 450px;\n      width: min(450px, calc(100vw - 40px));\n      padding: 48px 52px 42px;\n      border-radius: 20px;\n      box-shadow: 0 24px 70px rgba($color-black, 0.22);\n\n      .modalContent {\n        .modalHeader {\n          margin-bottom: 28px;\n\n          .iconContainer {\n            width: 76px;\n            height: 76px;\n\n            .modalIcon {\n              width: 30px;\n              height: 30px;\n              stroke-width: 2.8;\n            }\n          }\n        }\n\n        .modalBody {\n          margin-bottom: 32px;\n\n          .modalTitle {\n            max-width: 460px;\n            margin: 0 auto 20px;\n            font-size: 24px;\n            line-height: 1.22;\n            font-weight: 700;\n            letter-spacing: 0;\n          }\n\n          .modalMessage {\n            max-width: 450px;\n            font-size: 16px;\n            line-height: 1.58;\n            color: $color-text-grey;\n          }\n        }\n\n        .modalFooter {\n          .btnCancel {\n            min-width: 220px;\n            height: 50px;\n            padding: 0 34px;\n            border-radius: 8px;\n            border: 0;\n            font-size: 16px;\n            box-shadow: 0 10px 24px rgba($color-primary-pink, 0.26);\n          }\n        }\n      }\n\n      @include respond-md {\n        width: calc(100vw - 32px);\n        margin: 16px;\n        padding: 40px 28px 32px;\n        border-radius: 18px;\n\n        .modalContent {\n          .modalHeader {\n            margin-bottom: 24px;\n\n            .iconContainer {\n              width: 72px;\n              height: 72px;\n\n              .modalIcon {\n                width: 28px;\n                height: 28px;\n              }\n            }\n          }\n\n          .modalBody {\n            margin-bottom: 30px;\n\n            .modalTitle {\n              font-size: 20px;\n              line-height: 1.22;\n              margin-bottom: 18px;\n            }\n\n            .modalMessage {\n              max-width: 100%;\n              font-size: 16px;\n              line-height: 1.52;\n            }\n          }\n\n          .modalFooter {\n            .btnCancel {\n              width: 100%;\n              min-width: 0;\n              height: 52px;\n              font-size: 14px;\n            }\n          }\n        }\n      }\n  }\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n// contact us modal\n.contactModalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 20px;\n  color: $color-black;\n\n  .contactModal {\n    background: $color-white;\n    border-radius: 12px;\n    width: 100%;\n    max-width: 500px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 20px 25px -5px $color-border, 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n    \n    @include respond-md {\n      max-width: 400px;\n      margin: 10px;\n    }\n  }\n  \n  .modalHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 14px 24px;\n    border-bottom: 1px solid $color-gray-200;\n    margin-bottom: 24px;\n  \n    h2 {\n      margin: 0;\n      font-size: 24px;\n      font-weight: 600;\n      color: $color-gray-900;\n      \n      @include respond-md {\n        font-size: 20px;\n      }\n    }\n  \n    .closeBtn {\n      background: none;\n      border: none;\n      cursor: pointer;\n      padding: 8px;\n      border-radius: 6px;\n      color: $color-gray-500;\n      transition: all 0.2s ease;\n  \n      &:hover {\n        background-color: $color-gray-100;\n        color: $color-gray-700;\n      }\n  \n      &:focus {\n        outline: 2px solid $color-primary-pink;\n        outline-offset: 2px;\n      }\n    }\n  }\n  \n  .modalForm {\n    padding: 0 24px 24px;\n  \n    .formGroup {\n      margin-bottom: 20px;\n  \n      input,\n      textarea {\n        width: 100%;\n        padding: 12px 16px;\n        border: 1px solid $color-gray-300;\n        border-radius: 8px;\n        font-size: 16px;\n        transition: all 0.2s ease;\n        font-family: inherit;\n        \n        &:focus {\n          outline: none;\n          border-color: $color-primary-pink;\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n        }\n  \n        &::placeholder {\n          color: $color-gray-400;\n        }\n  \n        @include respond-md {\n          font-size: 16px;\n        }\n      }\n  \n      textarea {\n        resize: vertical;\n        min-height: 100px;\n      }\n  \n      // Phone input styling\n      .react-tel-input {\n        .contact-phone-input {\n          width: 100% !important;\n          padding: 12px 16px 12px 58px !important;\n          border: 1px solid $color-gray-300 !important;\n          border-radius: 8px !important;\n          font-size: 16px !important;\n          transition: all 0.2s ease !important;\n          font-family: inherit !important;\n          height: 50px;\n          \n          &:focus {\n            outline: none !important;\n            border-color: $color-primary-pink !important;\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\n          }\n  \n          @include respond-md {\n            font-size: 16px !important; // Prevent zoom on iOS\n          }\n        }\n  \n        .flag-dropdown {\n          border: 1px solid $color-gray-300 !important;\n          border-radius: 8px 0 0 8px !important;\n          background: $color-gray-50 !important;\n  \n          &:hover {\n            background: $color-gray-100 !important;\n          }\n  \n          .selected-flag {\n            padding: 0 8px !important;\n  \n            &:hover {\n              background: transparent !important;\n            }\n          }\n        }\n      }\n  \n      .error {\n        color: $color-red-500;\n        font-size: 14px;\n        margin-top: 4px;\n        margin-bottom: 0;\n  \n        &.phoneError {\n          margin-top: 4px;\n        }\n      }\n    }\n  \n    .success-message {\n      background-color: $color-green-100;\n      color: $color-green-800;\n      padding: 12px 16px;\n      border-radius: 8px;\n      margin-top: 16px;\n      font-size: 14px;\n      border-left: 4px solid $color-green;\n    }\n  }\n  \n  .modalActions {\n    display: flex;\n    gap: 12px;\n    justify-content: flex-end;\n    margin-top: 32px;\n  \n    @include respond-md {\n      flex-direction: column-reverse;\n      gap: 8px;\n    }\n  \n    .cancelBtn,\n    .submitBtn {\n      padding: 12px 24px;\n      border-radius: 8px;\n      font-size: 16px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      border: none;\n      \n      @include respond-md {\n        width: 100%;\n        padding: 14px 24px;\n      }\n  \n      &:disabled {\n        cursor: not-allowed;\n        opacity: 0.6;\n      }\n    }\n  \n    .cancelBtn {\n      background: $color-gray-100;\n      color: $color-gray-700;\n      border: 1px solid $color-gray-300;\n  \n      &:hover:not(:disabled) {\n        background: $color-gray-200;\n      }\n  \n      &:focus {\n        outline: 2px solid $color-gray-500;\n        outline-offset: 2px;\n      }\n    }\n  \n    .submitBtn {\n      background: $color-primary-pink;\n      color: $color-white;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      justify-content: center;\n  \n      &:hover:not(:disabled) {\n        background: $color-primary-pink;\n      }\n  \n      &:focus {\n        outline: 2px solid $color-primary-pink;\n        outline-offset: 2px;\n      }\n    }\n  }\n}\n}\n","// ====================================\n// 🎨 Color Variables\n// ====================================\n\n$color-white: #ffffff;\n$color-black: #000000;\n\n// Primary Colors\n$color-primary-pink: #EA2466;\n$color-secondary-pink: #F5437E;\n$color-primary-dark-grey: #383838;\n$color-primary-medium-grey: #4a4a4a;\n$color-primary-light-grey: #808080;\n$color-border-primary-grey: #e2e8f0;\n// $color-border-primary-grey: #b4b4b4;\n$color-text-grey: #616161;\n\n// Background Colors\n$bg-pink-10: #FDECF2; // approximated 10% of #EA2466\n$bg-white: #FFFFFF;\n$bg-light-grey-1: #E8E8E8;\n$bg-light-grey-2: #F7F7F7;\n$bg-light-grey-3: #EDEDED;\n\n// Misc Colors\n$color-green: #00A664;\n$color-yellow: #FECE00;\n$color-red: #EB0000;\n$border-color-light-grey: #DCDCDC;\n\n// Stroke Colors\n$stroke-pink: #E11F60;\n$stroke-black: #000000;\n$stroke-dark: #1E1E1E;\n$stroke-grey: #E5E5E5;\n\n// Hover Colors\n$hover-pink: #CB104E;\n$hover-dark-grey: #484848;\n// $hover-light-grey: #EDEDED;\n\n// ====================================\n// ****** Precious Metals Theme *******\n// ====================================\n\n// Base Colors--\n$color-foreground: #252525;\n$color-primary: #030213;\n$color-secondary: #f2f1fc;\n$color-muted: #ececf0;\n$color-muted-foreground: #717182;\n$color-accent: #e9ebef;\n$color-destructive: #d4183d;\n$color-border: rgba(0, 0, 0, 0.1);\n$color-input: transparent;\n$color-input-background: #f3f3f5;\n$color-switch-background: #cbced4;\n$color-ring: #b50000;\n\n// Chart Colors--\n$chart-1: #f18b00;\n$chart-2: #3a9ac3;\n$chart-3: #6d91db;\n$chart-4: #f2ab00;\n$chart-5: #f9a800;\n\n// Gray Scale--\n$color-gray-50: #f9fafb;\n$color-gray-100: #f3f4f6;\n$color-gray-200: #e5e7eb;\n$color-gray-300: #d1d5db;\n$color-gray-400: #9ca3af;\n$color-gray-500: #6b7280;\n$color-gray-600: #4b5563;\n$color-gray-700: #374151;\n$color-gray-800: #1f2937;\n$color-gray-900: #111827;\n$color-gray-950: #030712;\n\n// Gold Colors\n$color-gold-50: #fffbeb;\n$color-gold-100: #fef3c7;\n$color-gold-200: #fde68a;\n$color-gold-300: #fcd34d;\n$color-gold-400: #fbbf24;\n$color-gold-500: #f59e0b;\n$color-gold-600: #d97706;\n$color-gold-700: #b45309;\n$color-gold-800: #92400e;\n$color-gold-900: #78350f;\n\n// Silver Colors\n$color-silver-50: #f8fafc;\n$color-silver-100: #f1f5f9;\n$color-silver-200: #e2e8f0;\n$color-silver-300: #cbd5e1;\n$color-silver-400: #94a3b8;\n$color-silver-500: #64748b;\n$color-silver-600: #475569;\n$color-silver-700: #334155;\n$color-silver-800: #1e293b;\n$color-silver-900: #0f172a;\n\n// Blue Colors\n$color-blue-50: #eff6ff;\n$color-blue-100: #dbeafe;\n$color-blue-200: #bfdbfe;\n$color-blue-300: #93c5fd;\n$color-blue-400: #60a5fa;\n$color-blue-500: #3b82f6;\n$color-blue-600: #2563eb;\n$color-blue-700: #1d4ed8;\n$color-blue-800: #1e40af;\n$color-blue-900: #1e3a8a;\n\n// Green Colors (Additional to system green)\n$color-green-50: #f0fdf4;\n$color-green-100: #dcfce7;\n$color-green-200: #bbf7d0;\n$color-green-300: #86efac;\n$color-green-400: #4ade80;\n$color-green-500: #22c55e;\n$color-green-600: #00A664;\n$color-green-700: #15803d;\n$color-green-800: #166534;\n$color-green-900: #14532d;\n\n// Red Colors (Additional to system red)\n$color-red-50: #fef2f2;\n$color-red-100: #fee2e2;\n$color-red-200: #fecaca;\n$color-red-300: #fca5a5;\n$color-red-400: #f87171;\n$color-red-500: #ef4444;\n$color-red-600: #EB0000;\n$color-red-700: #b91c1c;\n$color-red-800: #991b1b;\n$color-red-900: #7f1d1d;\n\n// Purple Colors\n$color-purple-50: #f5f3ff;\n$color-purple-100: #f3e8ff;\n$color-purple-200: #e9d5ff;\n$color-purple-300: #d8b4fe;\n$color-purple-400: #c084fc;\n$color-purple-500: #a855f7;\n$color-purple-600: #9333ea;\n$color-purple-700: #7c3aed;\n$color-purple-800: #6b21a8;\n$color-purple-900: #581c87;\n\n// Indigo Colors\n$color-indigo-50: #eef2ff;\n$color-indigo-100: #e0e7ff;\n$color-indigo-200: #c7d2fe;\n$color-indigo-300: #a5b4fc;\n$color-indigo-400: #818cf8;\n$color-indigo-500: #6366f1;\n$color-indigo-600: #4f46e5;\n$color-indigo-700: #4338ca;\n$color-indigo-800: #3730a3;\n$color-indigo-900: #312e81;\n\n// yellow Colors\n$color-yellow-50: #fefce8;\n$color-yellow-100: #fef9c3;\n$color-yellow-200: #fef08a;\n$color-yellow-300: #fde047;\n$color-yellow-400: #facc15;\n$color-yellow-500: #eab308;\n$color-yellow-600: #ca8a04;\n$color-yellow-700: #a16207;\n$color-yellow-800: #854d0e;\n$color-yellow-900: #713f12;\n\n// Orange Colors\n$color-orange-50: #fff7ed;\n$color-orange-100: #ffedd5;\n$color-orange-200: #fed7aa; \n$color-orange-300: #fdba74;\n$color-orange-400: #fb923c;\n$color-orange-500: #f97316;\n$color-orange-600: #ea580c;\n$color-orange-700: #c2410c;\n$color-orange-800: #9a3412;\n$color-orange-900: #7c2d12;\n\n// pink Colors\n$color-pink-50: #fdf2f8;\n$color-pink-100: #fce7f3;\n$color-pink-200: #fbcfe8;\n$color-pink-300: #f9a8d4;\n$color-pink-400: #f472b6;\n$color-pink-500: #ec4899;\n$color-pink-600: #db2777;\n$color-pink-700: #be185d;\n$color-pink-800: #9d174d;\n$color-pink-900: #831843;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
